<template>
  <div class="header_div">
    <a-row>
      <a-col :span="6" class="header_logo">
        <img :src="logoImg" :height="30"> <span class="env_title">从会销售的AI名片开始</span>
      </a-col>
      <a-col :span="14" class="header_title" >
<!--        :gutter="[68,8]"-->
        <a-row type="flex" justify="end" align="middle" >
          <a-col :span="3" class="nav_item" @click="btnNavClick(0)">
            <div class="split_item">产品展示</div>
            <div class="split_item split_bottom" v-show="navIndex === 0"></div>
          </a-col>
          <a-col :span="3" class="nav_item" @click="btnNavClick(1)">
            <div class="split_item">知识库</div>
            <div class="split_item split_bottom" v-show="navIndex === 1"></div>
          </a-col>
<!--          v-if="!$store.state.isMeuHost"-->
          <a-col :span="3" class="nav_item" @click="btnNavClick(4)" v-if="!$store.state.isMeuHost">
            <div class="split_item">我的商城</div>
            <div class="split_item split_bottom" v-show="navIndex === 4"></div>
          </a-col>
          <a-col :span="3" class="nav_item" @click="btnNavClick(2)">
            <div class="split_item">下载</div>
            <div class="split_item split_bottom" v-show="navIndex === 2"></div>
            </a-col>
          <a-col :span="3" class="nav_item" @click="btnNavClick(3)">
            <div class="split_item">帮助中心</div>
            <div class="split_item split_bottom" v-show="navIndex === 3"></div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="4" class="header_avatar" justify="start">
        <a-row type="flex" justify="start" align="middle">
          <a-col :span="1" style="text-align: left;">
            <div class="split_div"></div>
          </a-col>
          <a-col style="margin-left: 5px">
            <span  @click="loginShow" class="login_txt" v-if="!haveLogin && !isMeuHost" >登录</span>
<!--            <span v-if="haveLogin" @click="exitShow" class="login_txt">退出</span>-->
          </a-col>
          <a-col v-if="haveLogin" style="display: flex;align-items: center;margin-left: 8px">
            <a-popconfirm trigger="hover" class="exitPop" placement="bottom" title="确认退出？" cancel-text="取消" ok-text="确定" @confirm="exitShow">
              <a-icon slot="icon" type="question-circle-o" style="color: #28E04A" />
              <div>
                <a-icon type="user" style="font-size:22px;line-height: 28px;margin-top: 3px"/>
                <span> {{ username }} </span>
              </div>
            </a-popconfirm>
            <!--            <img :src="avatarUrl" width="28" height="28">-->
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-modal
      title="身份校验"
      :visible="confirmLoading"
      @cancel="handleCancel"
      :maskClosable="true"
    >
      <template #footer>
        <div style="text-align: center">
          <a-button type="primary" @click="handleOk()" class="btn_query_project btn_sure" style="color: black;width: 120px;">确认</a-button>
        </div>
      </template>
      <div style="display: flex;text-align: center;justify-content: center">
        <a-spin v-if="loginMallLoading" size="large" style="margin-right: 10px"/>
        <p> {{ changePassWordText }}</p>
      </div>
    </a-modal>
<!--    message="Success Tips" -->
    <a-alert
      type="success"
      :message="alertText"
      v-if="showBanner"
    >
    </a-alert>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    navIndex: {
      type: Number,
      default: 0
    }
  },
  inject: ['showLogin'],
  computed: {
    username () {
      return this.$store.state.userAuth.username
    },
    haveLogin () {
      return this.$store.state.userAuth.haveLogin
    },
    showBanner () {
      return this.$store.state.userInfo.mall_state === 2
    },
    isMeuHost () {
      return this.$store.state.isMeuHost
    }
  },
  data () {
    return {
      msg: 'Welcome to Header App',
      haveLogin1: false,
      avatarUrl: require('@/assets/icon_avatar.png'),
      logoImg: require('@/assets/logo/logo.png'),
      visible: false,
      confirmLoading: false,
      loginMallLoading: false,
      changePassWordText: '',
      alertText: `为方便用户下单，现已上线商城系统。您可在 "我的商城" 中申请入驻。请注意∶入驻后，通过app上传的商品将被删除，请使用商城功能上架商品。`
    }
  },
  mounted () {
  },
  methods: {
    btnNavClick (index) {
      console.log('btnNavClick', index)
      switch (index) {
        case 0:
          this.$router.push('/')
          break
        case 1:
          this.$router.push('/base')
          break
        case 2:
          this.$router.push('/download')
          break
        case 3:
          this.$router.push('/help')
          break
        case 4:
          this.myShop()
          break
        default:
          break
      }
    },
    myShop () {
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录')
        return
      }
      this.changePassWordText = ''
      this.confirmLoading = true
      this.loginMallLoading = true
      // 读取用户信息
      this.$api.getUserInfo().then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData && typeof resData !== 'undefined') {
            if (resData.length > 0) {
              const userInfo = resData[0]
              this.$store.commit('updateUserInfo', userInfo)
              // console.log('userInfo', userInfo)
              if (userInfo.is_update_psd === 1) { //  1 未更新 2 已更新 是否更新密码
                this.changePassWordText = '为保障您的资金安全，请在喵呜 AI APP上重置密码后重新登录进入商城'
                this.loginMallLoading = false
                // 提示 结束等待效果 收到确认退出登录
                this.loginMallLoading = false
                // 退出操作
              } else if (userInfo.is_update_psd === 2) {
                // 已更新过密码
                // 跳转商城
                // 根据商城注册状态 取决是否注册和登录 都能取到商城token
                // 1、未注册 2、已注册，未入驻 3、已注册，已入驻
                if (userInfo.mall_state === 1) {
                  this.$api.mallRegister().then(res => {
                    if (res && res.status === 200) {
                      const resData = res.data.data
                      if (resData && typeof resData !== 'undefined') {
                        const mallToken = resData.mall_token
                        if (typeof mallToken !== 'undefined' && mallToken !== '') {
                          this.jumpShop(mallToken)
                        }
                        this.confirmLoading = false
                        this.loginMallLoading = false
                      }
                    } else {
                      // 关闭弹窗
                      this.confirmLoading = false
                      this.loginMallLoading = false
                      this.$message.error('商城注册失败')
                    }
                  }).catch(error => {
                    console.log('商城登录错误:', error)
                    this.$message.error(error.data.msg || '商城注册失败，请退出重试')
                    // 关闭弹窗
                    this.confirmLoading = false
                    this.loginMallLoading = false
                  })
                } else if (userInfo.mall_state === 2 || userInfo.mall_state === 3) {
                  this.$api.mallLogin().then(res => {
                    if (res && res.status === 200) {
                      const resData = res.data.data
                      if (resData && typeof resData !== 'undefined') {
                        const mallToken = resData.mall_token
                        if (typeof mallToken !== 'undefined' && mallToken !== '') {
                          this.jumpShop(mallToken)
                        }
                        this.confirmLoading = false
                        this.loginMallLoading = false
                      }
                    } else {
                      this.confirmLoading = false
                      this.loginMallLoading = false
                      this.$message.error('商城登录失败')
                    }
                  }).catch(error => {
                    console.log('商城登录错误:', error)
                    this.$message.error(error.data.msg || '商城登录失败，请退出重试')
                    // 关闭弹窗
                    this.confirmLoading = false
                    this.loginMallLoading = false
                  })
                } else {
                  this.loginMallLoading = false
                  this.confirmLoading = false
                  this.$message.error('商家信息获取失败：' + userInfo.mall_state)
                }
              }
            } else {
              this.$message.error('获取用户信息首条数据失败')
            }
          }
        } else {
          this.$message.error('用户信息获取失败' + res.status)
        }
      }).catch(error => {
        console.log('当前用户信息获取失败:', error)
        this.$message.error('当前用户信息获取失败')
      })
    },
    jumpShop (shopToken) {
      // 跳转商城 携带参数
      let link = document.createElement('a')
      const userId = this.$store.state.userAuth.accessToken
      // console.log('userId', userId)

      if (userId && typeof userId !== 'undefined') {
        const url = this.$store.state.shopHost + '?shop_token=' + shopToken + '&user_id=' + userId
        link.href = url
        // console.log('shop url', url)
        link.target = '_blank' // _self _blank// 设置属性为'_self'，在当前标签页打开链接

        // 将<a>元素添加到页面中
        document.body.appendChild(link)
        // 模拟点击<a>元素
        link.click()
        // 移除<a>元素
        document.body.removeChild(link)
      } else {
        this.$message.error('用户凭据信息未获取，请重新登录尝试')
      }
    },
    loginShow () {
      /* this.$router.push('/')
      this.$store.commit('updateShowPanel', true) */
      // this.$emit('showLogin')
      this.showLogin()
    },
    exitShow () {
      this.$store.commit('updateUserInfo', {mall_state: -1})
      this.$store.commit('updateUserAuth', {})
      this.$store.commit('updateUserAuth', {})
      this.$store.commit('updateProject0', {
        'ai_prompt': '',
        'comment': '默认项目',
        'db_prompt': '你是我的小助手，会帮我回答一些用户提问',
        'engine': 'ai',
        'id': -1,
        'max_tokens': 2048,
        'model': 'gpt-3.5-turbo',
        'name': '默认项目-',
        'owner': ''
      })
      this.$store.commit('updateShowPanel', false)
      localStorage.setItem('fileContentFull', '')
    },
    showModal () {
      this.confirmLoading = true
    },
    handleOk (e) {
      this.loginMallLoading = false
      this.confirmLoading = false
    },
    handleCancel (e) {
      console.log('Clicked cancel button')
      this.confirmLoading = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .ant-popover-buttons{
    .ant-btn-primary{
      background: #28E04A;
      border-color: #28E04A;
    }
    .ant-btn-primary:hover{
      background: #28E04A;
    }
  }
  .btn_sure{
    background: #28E04A !important;
    border-radius: 8px 8px 8px 8px;
    border-color: #28E04A !important;
    opacity: 1;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: #000c17 !important;
  }
  .btn_sure:hover{
    background: rgb(60, 244, 94) !important;
    color: #000c17 !important;
  }
</style>
<style lang="less">
  .header_div{
    width: 100vw;
    height: 130px;
    padding-top: 26px;
    color: #FFFFFF;
    line-height: 28px;
  }
  .header_logo{
    font-size: 14px;
    font-family: Calibri;
    .env_title{
      font-size: 16px;
      font-weight: 500;
      color: #54ac49;
      line-height: 19px;
      margin-bottom: 10px;
    }
  }
  .header_title{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    padding: 0 60px 0 60px;
    text-align: center;
  }
  .nav_item{
     width: 64px;
     height: 22px;
     margin: 0 22px;
  }
  .header_avatar{
    text-align: center;
    font-size: 16px;
    font-weight: 400;
   /* .loginDiv {
      position: relative;
      !* 其他样式属性 *!
    }*/
    .loginOutDiv {
      display: none;
      /* 其他样式属性 */
    }
    .loginDiv:hover + .loginOutDiv {
      display: block;
    }
  }
  .split_div{
    width: 2px;
    height: 22px;
    opacity: 0.6;
    border: 2px solid rgba(255,255,255,0.6);
    line-height: 28px;
    margin-top: 5px;
  }
  .split_item{
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .split_bottom{
    width: 64px;
    height: 4px;
    background: #28E04A;
    border-radius: 14px 14px 14px 14px;
    opacity: 1;
    display: inline-block;
    animation: zoomIn;
    animation-duration: .5s;
    animate-delay: 1.2s;
  }
  .login_txt{
    position: relative;
  }
  .login_txt::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue